export const CREATE_CONTACT_REQUEST = 'new-contacts/CREATE_CONTACT_REQUEST';
export const CREATE_CONTACT_SUCCESS = 'new-contacts/CREATE_CONTACT_SUCCESS';
export const CREATE_CONTACT_FAILURE = 'new-contacts/CREATE_CONTACT_FAILURE';

export const CREATE_CONTACTS_REQUEST = 'new-contacts/CREATE_CONTACTS_REQUEST';
export const CREATE_CONTACTS_SUCCESS = 'new-contacts/CREATE_CONTACTS_SUCCESS';
export const CREATE_CONTACTS_FAILURE = 'new-contacts/CREATE_CONTACTS_FAILURE';

export const CREATE_CONTACTS_SUBTASK_SUCCESS = 'new-contacts/CREATE_CONTACTS_SUBTASK_SUCCESS';
export const CREATE_CONTACTS_SUBTASK_FAILURE = 'new-contacts/CREATE_CONTACTS_SUBTASK_FAILURE';

export const INIT_CREATION_TASK = 'new-contacts/INIT_CREATION_TASK';

export const INIT_COUNT = 'new-contacts/INIT_COUNT';

export const createContactRequest = (payload = {}) => ({
  type: CREATE_CONTACT_REQUEST,
  payload,
});
export const createContactSuccess = (payload = {}) => ({
  type: CREATE_CONTACT_SUCCESS,
  payload,
});
export const createContactFailure = (payload = {}) => ({
  type: CREATE_CONTACT_FAILURE,
  payload,
});

export const createContactsRequest = (payload = {}) => ({
  type: CREATE_CONTACTS_REQUEST,
  payload,
});
export const createContactsSuccess = (payload = {}) => ({
  type: CREATE_CONTACTS_SUCCESS,
  payload,
});
export const createContactsFailure = (payload = {}) => ({
  type: CREATE_CONTACTS_FAILURE,
  payload,
});

export const createContactsSubtaskSuccess = (payload = {}) => ({
  type: CREATE_CONTACTS_SUBTASK_SUCCESS,
  payload,
});
export const createContactsSubtaskFailure = (payload = {}) => ({
  type: CREATE_CONTACTS_SUBTASK_FAILURE,
  payload,
});

export const initCreationTask = (payload = {}) => ({
  type: INIT_CREATION_TASK,
  payload,
});

export const initCount = (payload = {}) => ({
  type: INIT_COUNT,
  payload,
});
